/**
 * COPIED from pages/dev-agent/components/metadataEditor/AnalyzingShimmerBar.tsx.
 * No store coupling — pure presentational shimmer bar.
 */
export function AnalyzingShimmerBar({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <div className="relative h-1 w-full bg-blue-100 dark:bg-blue-950 overflow-hidden flex-shrink-0">
      <div
        className="absolute h-full w-1/3 bg-blue-500 rounded-full"
        style={{ animation: "shimmer 1.5s ease-in-out infinite" }}
      />
      <style>{`@keyframes shimmer { 0% { left: -33%; } 100% { left: 100%; } }`}</style>
    </div>
  );
}
